import { useContext, useEffect } from "react"
import ProfileContext from "../contexts/ProfileContext"

function ShowInfo() {
   const {setIsEditing, profileData, setProfileData} = useContext(ProfileContext)
   // const {}

   const switchToEdit = () => {
      setIsEditing(true)
   }
   const getAvatar = async (name, description,tags, username) => {
      fetch("https://webdev.cse.buffalo.edu/hci/api/api/deekstra"+"/file-uploads?uploaderID="+sessionStorage.getItem("user")+"&attributes=%7B%0A%20%20%22path%22%3A%20%22fileType%22%2C%0A%20%20%22equals%22%3A%20%22Avatar%22%0A%7D", {
            method: "get",
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': 'Bearer '+sessionStorage.getItem("token")
            }
          })
            .then(res => res.json())
            .then(
              result => {
                if (result) {
                  console.log(result);
                  //console.log(result[0][0]);
                  const img_data = result[0].pop();
                  if (img_data.path){   
                     const img_src = "https://webdev.cse.buffalo.edu" + img_data.path;
                     console.log('got src: ', img_src)
                     setProfileData({...profileData, ['profile_pic_src']: img_src,['name']:name || "",['description']: description || "", ['tags']: tags, ['username']: username});
                     console.log(profileData.profile_pic_src);
                  }
                }
              },
              error => {
                alert("error!");
              }
            );
   }
   useEffect(()=>{
      fetch("https://webdev.cse.buffalo.edu/hci/api/api/deekstra"+"/users/"+sessionStorage.getItem("user"), {
         method: "get",
         headers: {
           'Content-Type': 'application/json',
           'Authorization': 'Bearer '+ sessionStorage.getItem("token")
         }
       })
         .then(res => res.json())
         // .then(
         //   result => {
         //     if (result) {
         //       console.log(result);
         //       if (result.attributes){     
         //          setProfileData({...profileData, ['name']:result.attributes.name || "",['description']: result.attributes.description || ""});
   
         //     }
         //     }
         //   },
         //   error => {
         //     alert("error!");
         //   })
         .then(result => {
            if (result){
               if (result.attributes){
                  setProfileData({...profileData, ['name']:result.attributes.name || "",['description']: result.attributes.description || "", ['tags']: result.attributes.tags, ['username']:result.attributes.username});
                  getAvatar(result.attributes.name, result.attributes.description, result.attributes.tags, result.attributes.username)
               }
            }
         });
   },[]);
   
   return (
      <div className="profile_avatarSection">
         <div className="avatarSection_avatar">
            <img
               src= {profileData.profile_pic_src}
               alt={"Avatar"}
               className="avatarSection_avatar_image"
            />
         </div>
         <div className="avatarSection_description">
            <div className="avatarSection_description_name">{profileData.name}</div>
            <div className="majorSection">
               <div className="major_text"><b>Major:</b> {profileData.tags.major=='' ? 'Not Specified' : profileData.tags.major}</div>
            </div>
            <div className="avatarSection_description_tags">
               <ul className="avatarSection_tagsList">
                  {(profileData.tags.status === "Freshman") && (<li className="tag_freshman">Freshman</li>)}
                  {(profileData.tags.status === "Sophomore") && (<li className="tag_sophomore">Sophomore</li>)}
                  {(profileData.tags.status === "Junior") && (<li className="tag_junior">Junior</li>)}
                  {(profileData.tags.status === "Senior") && (<li className="tag_senior">Senior</li>)}
                  {(profileData.tags.status === "Graduate") && (<li className="tag_graduate">Graduate</li>)}
               </ul>
            </div>
            <div className="avatarSection_description_description">
               {profileData.description}
            </div>
            <div className="avatarSection_description_buttons">
               <div onClick={switchToEdit} className="avatarSection_description_buttons_button">
                  Edit Profile
               </div>
            </div>
         </div>
      </div>
   )
}
export default ShowInfo